module.exports = "/_next/static/chromiums/fav-96x96-icon-452fe38139b0c563e4b8a9582a1f9052.png";